import * as React from 'react'

export function TabbarHome(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M27.663 14.191L16.708 4.278a1.044 1.044 0 00-1.416-.003L4.34 14.188c-.7.644-.245 1.812.707 1.812H6.99l-.013 11a1 1 0 001 1h9.011v-6a1 1 0 011.001-1h2.002a1 1 0 011.002 1v6H23.986a1 1 0 001-1L25 16h1.953c.95 0 1.407-1.164.71-1.809'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
